var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "consolidator-wallet-filter",
      class: { "consolidator-wallet-filter--stacked": _vm.stacked }
    },
    [
      _vm._l(_vm.resolvedFields, function(field) {
        return _c(
          "div",
          {
            key: field.key,
            staticClass: "consolidator-wallet-filter__field",
            class: {
              "consolidator-wallet-filter__field--flex":
                field.key === "filtroData"
            }
          },
          [
            _c("div", { staticClass: "az-text-label" }, [
              _vm._v(" " + _vm._s(field.label) + " ")
            ]),
            _c("input-by-type", {
              key: field.key + "-" + _vm.selectRemountKey,
              ref: "fieldInputs",
              refInFor: true,
              attrs: {
                type: "select-search",
                value: _vm.getFieldValue(field.key),
                options: _vm.toSelectSearchItems(field),
                single: !field.multiple,
                "require-selection": !field.multiple,
                "preserve-items-order": "",
                "selection-text": _vm.getFieldDisplayLabel(field),
                "return-by": "id",
                disabled: _vm.disabled,
                loading: _vm.walletAnalysisOptionsFieldsLoading
              },
              on: {
                input: function($event) {
                  return _vm.handleFieldChange(field, $event)
                },
                apply: function($event) {
                  return _vm.handleFieldApply(field, $event)
                },
                reselect: function($event) {
                  return _vm.onReselect(field, $event)
                }
              }
            })
          ],
          1
        )
      }),
      _c("WalletCustomDate")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }